export default "__VITE_ASSET__Cmc6zd$L__"